export class ApplicationAccessLevels {
  static View = 'view'
  static Edit = 'edit'
  static Duplicate = 'duplicate'
  static Draft = 'draft'
}
